import { Navigate, Outlet } from "react-router-dom";
import { getPortalFromHostname } from "@/components/DomainRouter";

/**
 * Guards a portal route group so it only renders on the correct domain.
 * On non-production domains (dev, preview), all portals are accessible.
 */
export function PortalDomainGuard({ 
  portal, 
  children 
}: { 
  portal: "hire" | "seek" | "admin";
  children?: React.ReactNode;
}) {
  const currentPortal = getPortalFromHostname();
  
  // On dev/preview (no portal-specific domain), allow everything
  if (!currentPortal) {
    return children ? <>{children}</> : <Outlet />;
  }
  
  // On a portal-specific domain, only allow matching portal
  if (currentPortal !== portal) {
    // Redirect to the root of the current portal's domain
    const redirectMap: Record<string, string> = {
      hire: "/dashboard",
      seek: "/seek",
      admin: "/super-admin",
    };
    return <Navigate to={redirectMap[currentPortal]} replace />;
  }
  
  return children ? <>{children}</> : <Outlet />;
}
